@if (hasAction) {
  <div class="c__footer" [ngClass]="{'is-visually-hidden': isMinified}">
    <sd-product-actions
      [brand]="brand"
      [isLoading]="isLoading"
      [horizontalParentLayout]="horizontalLayout"
      [isProductComparator]="productInfo?.isProductComparator"
      (cart)="addToCart()"
      [(isCompared)]="isCompared"
      (isComparedChange)="addToComparator($event)"
      (favorite)="addToFavorite()"
      (notify)="stockNotify()"
      [onSale]="productInfo?.onSale"
      [isInStock]="productInfo?.stock?.online"
      [hasPrice]="!!productInfo?.price"
      [isInFavorite]="productInfo?.isInFavorite"
      [isSmall]="isSmall"
      [productName]="productInfo?.title"
    />
  </div>
}
<div class="c__product-card-parts">
  <div class="c__body">
    @if (productInfo?.tags && !isSmall && !isLoading) {
      <div class="c__tags">
        @for (tag of productInfo?.tags; track tag.text) {
          <sd-tag [tagData]="tag" />
        }
      </div>
    }
    <sd-product-info
      [brand]="brand"
      [isSSR]="isSSR"
      [indexFollow]="indexFollow"
      [isLoading]="isLoading"
      [titleLevel]="titleLevel"
      [largeTitle]="largeTitle"
      [brandLogoTitle]="productInfo?.brandLogoTitle"
      [ratings]="(productInfo?.ratings?.averageRatings || productInfo?.ratings?.numberOfReviews) ? productInfo?.ratings : null"
      [displayStock]="displayStock && productInfo?.onSale && !!productInfo?.price"
      [isSmall]="isSmall"
      [isMinified]="isMinified"
      [discountedPrice]="productInfo?.discountedPrice"
      [title]="productInfo?.title"
      [subtitle]="productInfo?.subtitle"
      [price]="productInfo?.price"
      [ecoTax]="productInfo?.ecoTax"
      [benefits]="productInfo?.benefits"
      [stock]="productInfo?.stock"
      [productUrl]="productInfo?.url"
      [recommendedPrice]="productInfo?.recommendedPrice"
      [productSeller]="productInfo?.seller"
      [onSale]="productInfo?.onSale"
      [isSmallRecommendedPrice]="true"
      [isDiscountWithRecommendedPrice]="productInfo?.isDiscountWithRecommendedPrice"
      [isTaxesIncluded]="productInfo?.isTaxesIncluded"
      [isBundle]="isBundle"
      [hideRatingLabel]="isBundle ? ('bundle.ratingandreviews.rating.hide' | translate) : ( productInfo?.isAccessory
        ? ('productcard.ratingandreviews.accessory.rating.hide' | translate )
        : ('productcard.ratingandreviews.rating.hide' | translate))"
      [hideRatingStars]="isBundle ? ('bundle.ratingandreviews.stars.hide' | translate) : (productInfo?.isAccessory
        ? ('productcard.ratingandreviews.accessory.stars.hide' | translate)
        : ('productcard.ratingandreviews.stars.hide' | translate))"
      [hideRatingNumber]="isBundle ? ('bundle.ratingandreviews.reviewsNumber.hide' | translate) : (productInfo?.isAccessory
        ? ('productcard.ratingandreviews.accessory.reviewsNumber.hide' | translate)
        : ('productcard.ratingandreviews.reviewsNumber.hide' | translate))"
      [productCode]="productInfo?.cmmf"
      [productRefSAV]="productInfo?.refSAV"
      [showRef]="showRef"
      [horizontalParentLayout]="horizontalLayout"
      [ratingSize]="horizontalLayout ? sizeEnum.xs : sizeEnum.s"
      (reviewsSeeAllClicked)="onReviewsSeeAllClicked()"
      (productClicked)="onProductClick()"
      (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
    />
  </div>
  <div class="c__product-card-left">
    @if (productInfo?.media?.url || productInfo?.media?.urlTwicPic) {
      <div class="c__media-wrapper {{imageHasBorder && !horizontalLayout ? 'has-border' : ''}}">
        <sd-banner
          [isComponentLoading]="isLoading"
          [media]="productInfo?.media"
          [isFit]="true"
          [imgRatio]="imageRatio"
          [hasAltText]="false"
          [twicPicsAutoSize]="twicPicsAutoSize"
        />
        @if (!isMinified) {
          <div class="c__product-other-infos">
            <div class="c__product-other-infos-left">
              @if (productInfo?.reparabilityData && !productInfo?.refurbishedLogo) {
                <sd-reparability
                  sd-reparability
                  [isSmall]="true"
                  [showInfo]="false"
                  [reparabilityData]="productInfo?.reparabilityData"
                />
              }
              @if (productInfo?.refurbishedLogo && (!isSmall || !!showRefurbishedLogo)) {
                <sd-product-logo [media]="productInfo?.refurbishedLogo" [width]="87" />
              }
              @if (productInfo?.madeInData && !isSmall) {
                <sd-product-logo [media]="productInfo?.madeInData" />
              }
            </div>
            <div class="c__product-other-infos-right">
              @if (productInfo?.brandLogo?.media) {
                <sd-banner class="c__brand-logo"
                  [isFit]="true"
                  [media]="productInfo?.brandLogo?.media"
                />
              }
            </div>
          </div>
        }
      </div>
    }
    @if (productInfo?.isProductComparator && horizontalLayout) {
      <sd-form checkbox
        (checkedChange)="addToComparator($event)"
        [(checked)]="isCompared"
        [labelTitle]="(('comparator.add' | translate ) || '...') + '<span class=is-visually-hidden>' + productInfo?.title + '</span>'"
        nameField="addToCompare"
      />
    }
  </div>
</div>
